export default class Cluster {
    constructor () {
        this.id = null
        this.name = ""
        this.terraform_state_bucket = 'codium-terraform-states'
        this.terraform_state_key = 'terraform.tfstate'
        this.terraform_state_region = 'ap-southeast-2'
        this.terraform_aws_region = 'ap-southeast-2'
        this.terraform_az_count = '2'
        this.terraform_key_name = 'carbon'
        this.terraform_instance_type = 't2-medium'
        this.terraform_asg_min = '0'
        this.terraform_asg_max = '5'
        this.terraform_asg_desired = '1'
        this.terraform_admin_cidr_ingress = '103.232.210.221/32'
        this.terraform_rds_username = 'root'
        this.terraform_rds_password = null
        this.production = 0
    }
}